<section class="app-hom-pil" [id]="HomeSection.PILLARS">
  <div class="container app-hom-pil__con">
    <h2 class="app-hom-pil__con__tit">PRO.CONNECT to</h2>

    <div class="scroll-x-mob d-md-block d-none">
      <ul class="list-unstyled app-hom-pil__con__ul">
        <li class="app-hom-pil__con__ul__li">
          <a
            [routerLink]="['/' + (user() ? WwwRouteSlug.ACCOUNT + '/' : '') + WwwRouteSlug.PRO_EXPERIENCE]"
            appGtmClick
            [layer]="{
              event: 'uaevent',
              ecommerce: 'undefined',
              eventCategory: 'home page',
              eventAction: 'select::go to pro experience page',
              eventLabel:
                'go to pro experience page::' +
                '/' +
                (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EXPERIENCE : '/' + WwwRouteSlug.PRO_EXPERIENCE),
              event_name: 'body_button_click',
              module_name: 'pro experience',
              cta_name: 'go to pro experience page',
              link_url:
                '/' +
                (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EXPERIENCE : '/' + WwwRouteSlug.PRO_EXPERIENCE),
            }"
          >
            <div class="app-hom-pil__con__ul__li__fig second">
              <img
                class="app-hom-pil__con__ul__li__fig__bg"
                alt="experience"
                src="assets/images/pages/home/experience.webp"
                width="435"
                height="547"
              />
              <div class="app-hom-pil__con__ul__li__fig__bbg"></div>

              <img
                class="app-hom-pil__con__ul__li__fig__img"
                alt="experience"
                src="assets/images/pages/home/experience.svg"
                width="231"
                height="23"
              />
              <div class="app-hom-pil__con__ul__li__fig__fig">
                <img
                  class="app-hom-pil__con__ul__li__fig__fig__img"
                  alt="support"
                  src="assets/images/pages/home/experience-circle.webp"
                  width="433"
                  height="547"
                />
                <p class="app-hom-pil__con__ul__li__fig__fig__p">
                  <strong>Pakiet doświadczeń </strong><br />

                  Od podróży po eventy networkingowe. <br />
                  Poznaj trendy i zainspiruj się pracą <br />
                  z profesjonalistami z całego świata.
                </p>
                <span class="app-hom-pil__con__ul__li__fig__fig__more">DOWIEDZ SIĘ WIĘCEJ</span>

                <div class="circle-2"></div>
              </div>
            </div>
          </a>
        </li>
        <li class="app-hom-pil__con__ul__li">
          <a
            [routerLink]="['/' + (user() ? WwwRouteSlug.ACCOUNT + '/' : '') + WwwRouteSlug.PRO_EDUCATION]"
            appGtmClick
            [layer]="{
              event: 'uaevent',
              ecommerce: 'undefined',
              eventCategory: 'home page',
              eventAction: 'select::go to pro education page',
              eventLabel:
                'go to pro education page::' +
                '/' +
                (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EDUCATION : '/' + WwwRouteSlug.PRO_EDUCATION),
              event_name: 'body_button_click',
              module_name: 'pro education',
              cta_name: 'go to pro education page',
              link_url:
                '/' +
                (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EDUCATION : '/' + WwwRouteSlug.PRO_EDUCATION),
            }"
          >
            <div class="app-hom-pil__con__ul__li__fig first">
              <img
                class="app-hom-pil__con__ul__li__fig__bg"
                alt="education"
                src="assets/images/pages/home/education.webp"
                width="435"
                height="547"
              />

              <div class="app-hom-pil__con__ul__li__fig__bbg"></div>
              <img
                class="app-hom-pil__con__ul__li__fig__img"
                alt="education"
                src="assets/images/pages/home/education.svg"
                width="207"
                height="19.65"
              />
              <div class="app-hom-pil__con__ul__li__fig__fig">
                <img
                  class="app-hom-pil__con__ul__li__fig__fig__img"
                  alt="education"
                  src="assets/images/pages/home/education-circle.webp"
                  width="433"
                  height="547"
                />
                <p class="app-hom-pil__con__ul__li__fig__fig__p">
                  <strong>Kompleksowa edukacja </strong><br />
                  Nowoczesne szkolenia dostosowane do<br />
                  potrzeb osób zarządzających salonami<br />
                  fryzjerskimi, które chcą stale rozwijać<br />
                  usługi i biznes.
                </p>
                <span class="app-hom-pil__con__ul__li__fig__fig__more">DOWIEDZ SIĘ WIĘCEJ</span>

                <div class="circle-3"></div>
              </div>
            </div>
          </a>
        </li>

        <li class="app-hom-pil__con__ul__li">
          <a
            [routerLink]="[
              '/' + (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.MY_DATA : WwwRouteSlug.PRO_SUPPORT),
            ]"
            appGtmClick
            [layer]="{
              event: 'uaevent',
              ecommerce: 'undefined',
              eventCategory: 'home page',
              eventAction: 'select::go to pro support page',
              eventLabel:
                'go to pro support page::' +
                '/' +
                (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_SUPPORT : '/' + WwwRouteSlug.PRO_SUPPORT),
              event_name: 'body_button_click',
              module_name: 'pro support',
              cta_name: 'go to pro support page',
              link_url:
                '/' + (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_SUPPORT : '/' + WwwRouteSlug.PRO_SUPPORT),
            }"
          >
            <div class="app-hom-pil__con__ul__li__fig third">
              <img
                class="app-hom-pil__con__ul__li__fig__bg"
                alt="support"
                src="assets/images/pages/home/support.webp"
                width="435"
                height="547"
              />
              <div class="app-hom-pil__con__ul__li__fig__bbg"></div>

              <img
                class="app-hom-pil__con__ul__li__fig__img"
                alt="support"
                src="assets/images/pages/home/support.svg"
                width="181"
                height="19.65"
              />
              <div class="app-hom-pil__con__ul__li__fig__fig">
                <img
                  class="app-hom-pil__con__ul__li__fig__fig__img"
                  alt="support"
                  src="assets/images/pages/home/support-circle.webp"
                  width="433"
                  height="547"
                />
                <p class="app-hom-pil__con__ul__li__fig__fig__p">
                  <strong>Zasoby do rozwoju biznesu </strong><br />

                  Pełne wsparcie w obszarze materialnym<br />
                  oraz szkoleniowym. Od ofert na sprzęt<br />
                  fryzjerski, przez inwestycje salonowe,<br />
                  po zniżki u partnerów.
                </p>

                <span class="app-hom-pil__con__ul__li__fig__fig__more">DOWIEDZ SIĘ WIĘCEJ</span>

                <div class="circle-1"></div>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="app-hom-pil__con__swi d-block d-md-none">
      <ul class="list-unstyled app-hom-pil__con__ul">
        <swiper-container [config]="swiperConfig" class="app-hom-pil__con__swi__sli" wwwSwiper init="false">
          <swiper-slide [ngClass]="{ 'app-hom-pil__con__swi__sli__sl': true }" swiperSlide role="button">
            <li class="app-hom-pil__con__ul__li">
              <a
                [routerLink]="['/' + (user() ? WwwRouteSlug.ACCOUNT + '/' : '') + WwwRouteSlug.PRO_EXPERIENCE]"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'home page',
                  eventAction: 'select::go to pro experience page',
                  eventLabel:
                    'go to pro experience page::' +
                    '/' +
                    (user()
                      ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EXPERIENCE
                      : '/' + WwwRouteSlug.PRO_EXPERIENCE),
                  event_name: 'body_button_click',
                  module_name: 'pro experience',
                  cta_name: 'go to pro experience page',
                  link_url:
                    '/' +
                    (user()
                      ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EXPERIENCE
                      : '/' + WwwRouteSlug.PRO_EXPERIENCE),
                }"
              >
                <div class="app-hom-pil__con__ul__li__fig second">
                  <img
                    class="app-hom-pil__con__ul__li__fig__bg"
                    alt="experience"
                    src="assets/images/pages/home/experience.webp"
                    width="435"
                    height="547"
                  />
                  <div class="app-hom-pil__con__ul__li__fig__bbg"></div>

                  <img
                    class="app-hom-pil__con__ul__li__fig__img"
                    alt="experience"
                    src="assets/images/pages/home/experience.svg"
                    width="231"
                    height="23"
                  />
                  <div class="app-hom-pil__con__ul__li__fig__fig">
                    <img
                      class="app-hom-pil__con__ul__li__fig__fig__img"
                      alt="support"
                      src="assets/images/pages/home/experience-circle.webp"
                      width="433"
                      height="547"
                    />
                    <p class="app-hom-pil__con__ul__li__fig__fig__p">
                      <strong>Pakiet doświadczeń </strong><br />

                      Od podróży po eventy networkingowe. <br />
                      Poznaj trendy i zainspiruj się pracą <br />
                      z profesjonalistami z całego świata.
                    </p>
                    <span class="app-hom-pil__con__ul__li__fig__fig__more">DOWIEDZ SIĘ WIĘCEJ</span>

                    <div class="circle-2"></div>
                  </div>
                </div>
              </a>
            </li>
          </swiper-slide>
          <swiper-slide [ngClass]="{ 'app-hom-pil__con__swi__sli__sl': true }" swiperSlide role="button">
            <li class="app-hom-pil__con__ul__li">
              <a
                [routerLink]="['/' + (user() ? WwwRouteSlug.ACCOUNT + '/' : '') + WwwRouteSlug.PRO_EDUCATION]"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'home page',
                  eventAction: 'select::go to pro education page',
                  eventLabel:
                    'go to pro education page::' +
                    '/' +
                    (user()
                      ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EDUCATION
                      : '/' + WwwRouteSlug.PRO_EDUCATION),
                  event_name: 'body_button_click',
                  module_name: 'pro education',
                  cta_name: 'go to pro education page',
                  link_url:
                    '/' +
                    (user()
                      ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_EDUCATION
                      : '/' + WwwRouteSlug.PRO_EDUCATION),
                }"
              >
                <div class="app-hom-pil__con__ul__li__fig first">
                  <img
                    class="app-hom-pil__con__ul__li__fig__bg"
                    alt="education"
                    src="assets/images/pages/home/education.webp"
                    width="435"
                    height="547"
                  />

                  <div class="app-hom-pil__con__ul__li__fig__bbg"></div>
                  <img
                    class="app-hom-pil__con__ul__li__fig__img"
                    alt="education"
                    src="assets/images/pages/home/education.svg"
                    width="207"
                    height="19.65"
                  />
                  <div class="app-hom-pil__con__ul__li__fig__fig">
                    <img
                      class="app-hom-pil__con__ul__li__fig__fig__img"
                      alt="education"
                      src="assets/images/pages/home/education-circle.webp"
                      width="433"
                      height="547"
                    />
                    <p class="app-hom-pil__con__ul__li__fig__fig__p">
                      <strong>Kompleksowa edukacja </strong><br />
                      Nowoczesne szkolenia dostosowane do<br />
                      potrzeb osób zarządzających salonami<br />
                      fryzjerskimi, które chcą stale rozwijać<br />
                      usługi i biznes.
                    </p>
                    <span class="app-hom-pil__con__ul__li__fig__fig__more">DOWIEDZ SIĘ WIĘCEJ</span>

                    <div class="circle-3"></div>
                  </div>
                </div>
              </a>
            </li>
          </swiper-slide>
          <swiper-slide [ngClass]="{ 'app-hom-pil__con__swi__sli__sl': true }" swiperSlide role="button">
            <li class="app-hom-pil__con__ul__li">
              <a
                [routerLink]="[
                  '/' + (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.MY_DATA : WwwRouteSlug.PRO_SUPPORT),
                ]"
                appGtmClick
                [layer]="{
                  event: 'uaevent',
                  ecommerce: 'undefined',
                  eventCategory: 'home page',
                  eventAction: 'select::go to pro support page',
                  eventLabel:
                    'go to pro support page::' +
                    '/' +
                    (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_SUPPORT : '/' + WwwRouteSlug.PRO_SUPPORT),
                  event_name: 'body_button_click',
                  module_name: 'pro support',
                  cta_name: 'go to pro support page',
                  link_url:
                    '/' +
                    (user() ? WwwRouteSlug.ACCOUNT + '/' + WwwRouteSlug.PRO_SUPPORT : '/' + WwwRouteSlug.PRO_SUPPORT),
                }"
              >
                <div class="app-hom-pil__con__ul__li__fig third">
                  <img
                    class="app-hom-pil__con__ul__li__fig__bg"
                    alt="support"
                    src="assets/images/pages/home/support.webp"
                    width="435"
                    height="547"
                  />
                  <div class="app-hom-pil__con__ul__li__fig__bbg"></div>

                  <img
                    class="app-hom-pil__con__ul__li__fig__img"
                    alt="support"
                    src="assets/images/pages/home/support.svg"
                    width="181"
                    height="19.65"
                  />
                  <div class="app-hom-pil__con__ul__li__fig__fig">
                    <img
                      class="app-hom-pil__con__ul__li__fig__fig__img"
                      alt="support"
                      src="assets/images/pages/home/support-circle.webp"
                      width="433"
                      height="547"
                    />
                    <p class="app-hom-pil__con__ul__li__fig__fig__p">
                      <strong>Zasoby do rozwoju biznesu </strong><br />

                      Pełne wsparcie w obszarze materialnym<br />
                      oraz szkoleniowym. Od ofert na sprzęt<br />
                      fryzjerski, przez inwestycje salonowe,<br />
                      po zniżki u partnerów.
                    </p>

                    <span class="app-hom-pil__con__ul__li__fig__fig__more">DOWIEDZ SIĘ WIĘCEJ</span>

                    <div class="circle-1"></div>
                  </div>
                </div>
              </a>
            </li>
          </swiper-slide>
        </swiper-container>
      </ul>

      <div class="app-hom-pil__con__swi__nav">
        <div class="app-hom-pil__con__swi__nav--prev"></div>
        <div class="app-hom-pil__con__swi__nav--pag"></div>
        <div class="app-hom-pil__con__swi__nav--next"></div>
      </div>
    </div>
  </div>
</section>
